var map = {
	"./aolenberg.mp4": 1198,
	"./astarczyk.mp4": 4295,
	"./ayalcin.mp4": 6900,
	"./bdevletli.mp4": 3982,
	"./bleisten.mp4": 3525,
	"./bniemeier.mp4": 897,
	"./dlittau.mp4": 8422,
	"./dmanns.mp4": 8864,
	"./efrantzen.mp4": 4474,
	"./jctvrtnicek.mp4": 6164,
	"./jnickel.mp4": 3581,
	"./liolenberg.mp4": 6782,
	"./lolenberg.mp4": 3395,
	"./mmohnke.mp4": 8438,
	"./nretzlaff.mp4": 6407,
	"./sdukkardt.mp4": 3020,
	"./skeilbach.mp4": 8279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9321;